module.exports = __webpack_public_path__ + "img/c14.b15cde4a.png";